import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { NAV } from "@/constants/testIds";
import GwnMark from "@/components/GwnMark";

export default function Header() {
  const [open, setOpen] = useState(false);
  const linkClass = ({ isActive }) =>
    `font-oswald uppercase text-sm tracking-widest px-3 py-2 border-b-2 ${
      isActive ? "border-[#1f63c9] text-white" : "border-transparent text-gray-300 hover:text-white hover:border-white/30"
    } transition-colors`;

  return (
    <header
      data-testid={NAV.header}
      className="sticky top-0 z-40 w-full border-b border-white/10 bg-[#0a1222]/80 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        {/* On-air white brand banner — mirrors the broadcast TvBanner block */}
        <Link
          to="/"
          data-testid={NAV.logo}
          className="group flex items-center"
        >
          <div className="flex items-center gap-3 rounded-[4px] bg-white px-3 py-1.5 shadow-[0_6px_22px_rgba(0,0,0,0.4)] transition-transform duration-200 group-hover:-translate-y-0.5">
            <GwnMark size={42} />
            <div className="leading-none">
              <div className="font-oswald text-[22px] font-black uppercase tracking-tight text-[#0a0f1c] sm:text-[26px]">
                Georgia
              </div>
              <div className="font-oswald text-[10px] font-bold uppercase tracking-[0.14em] text-[#1f63c9] sm:text-[11px]">
                Weather Network
              </div>
            </div>
          </div>
          <div className="sr-only">Georgia Weather Network</div>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          <NavLink to="/" end className={linkClass} data-testid={NAV.linkLive}>Live</NavLink>
          <NavLink to="/radar" className={linkClass} data-testid="nav-link-radar">Radar</NavLink>
          <NavLink to="/gameday" className={linkClass} data-testid="nav-link-gameday">Gameday</NavLink>
          <NavLink to="/forecast" className={linkClass} data-testid={NAV.linkForecast}>Forecast</NavLink>
          <a href="/#team" className="font-oswald uppercase text-sm tracking-widest px-3 py-2 text-gray-300 hover:text-white transition-colors" data-testid={NAV.linkTeam}>Team</a>
          <NavLink to="/admin" className={linkClass} data-testid={NAV.linkAdmin}>Admin</NavLink>
        </nav>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid={NAV.mobileToggle}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0a1222]/95">
          <div className="flex flex-col p-2">
            <NavLink to="/" end className={linkClass} onClick={() => setOpen(false)}>Live</NavLink>
            <NavLink to="/radar" className={linkClass} onClick={() => setOpen(false)}>Radar</NavLink>
            <NavLink to="/gameday" className={linkClass} onClick={() => setOpen(false)}>Gameday</NavLink>
            <NavLink to="/forecast" className={linkClass} onClick={() => setOpen(false)}>Forecast</NavLink>
            <a href="/#team" className="font-oswald uppercase text-sm tracking-widest px-3 py-2 text-gray-300" onClick={() => setOpen(false)}>Team</a>
            <NavLink to="/admin" className={linkClass} onClick={() => setOpen(false)}>Admin</NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
